import { Injectable } from '@angular/core';

// Simple session ID generator (UUID v4-like)
@Injectable({ providedIn: 'root' })
export class SessionService {
  getSessionId(): string {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = this.generateSessionId();
      sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  }

  private generateSessionId(): string {
    // Generate a random UUID v4 using cryptographically secure random values
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    // Fallback using cryptographically secure crypto.getRandomValues
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const arr = new Uint8Array(16);
      crypto.getRandomValues(arr);
      arr[6] = (arr[6] & 0x0f) | 0x40; // Set version to 4
      arr[8] = (arr[8] & 0x3f) | 0x80; // Set variant to RFC 4122
      return Array.from(arr, (byte) => byte.toString(16).padStart(2, '0'))
        .join('')
        .replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
    }
    // Last resort fallback (should rarely occur in modern browsers)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const randomValue = new Uint32Array(1);
      crypto.getRandomValues(randomValue);
      const r = (randomValue[0] % 16);
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
